import axios from 'axios';


export default {
    getConfiguration:()=>{
        return axios.get('configuracion/cliente')
    },

    updateTeamInfo(data){
        return axios.post('actualizar/equipo', data);
    },

    //Categorias de venta
    getCategories(){
        return axios.get('catalogos/categorias')
    },

    createCategory(data){
        return axios.post('equipo/agregar/categoria', data);
    },

    updateCategory(data, categoryId){
        return axios.post('equipo/actualizar/categoria/'+categoryId, data);
    },

    deleteCategory(categoryId){
        return axios.delete('equipo/eliminar/categoria/'+categoryId);
    },

    //Valores por default
    updateDefaultValues(data){
        return axios.post('valores/default', data);
    },

    //Configuración de equipo
    getMembersList(){
        return axios.get('equipo/listado')
    },
    deleteTeamMember(id){
        return axios.delete('equipo/eliminar/miembro/'+id);
    },
    sendInvitation(data){
        return axios.post('equipo/invitar/usuario', data);
    },
    selectAdmin(id){
        return axios.get('equipo/hacer/administrador/'+id)
    },

    //Configuración de cuenta
    getMeData:() => {
        return axios.get('auth/me')
    },
    updateMeData(data){
        return axios.post('actualizar/cuenta', data);
    },
    deleteAccount(){
        return axios.delete('borrar/cuenta');
    },

    //Envio de correos
    saveFirstEmailConfiguration(data){
        return axios.post('equipo/guardar/primer/correo', data);
    },
    saveReminderEmailConfiguration(data){
        return axios.post('equipo/guardar/recordatorio/correo', data);
    },
    saveApprovedEmailConfiguration(data){
        return axios.post('equipo/guardar/aprobacion/correo', data);
    }
  
}